import makeApi from '@lib/api'
import utils from '@lib/utils'

interface ChangeEmailRequest {
  email: string
}

interface ChangeEmailParams {
  userId: string
  retailerPartnerNumber: number
}

export interface ChangePasswordRequest {
  newPassword: string
  currentPassword?: string
  verificationCode?: string
}

interface ChangePasswordParams {
  userId: string
  retailerPartnerNumber: number
}

export interface ResetPasswordRequest {
  email: string
}

export default {
  changeEmail: async ({ userId, retailerPartnerNumber, email }: ChangeEmailParams & ChangeEmailRequest) => {
    const callApi = makeApi.put<{}, ChangeEmailRequest, void>(
      `/v1/retailers/${retailerPartnerNumber}/users/${userId}/change-email`,
    )

    return await callApi({ params: {}, body: { email } })
  },
  changePassword: async ({ userId, retailerPartnerNumber, ...body }: ChangePasswordParams & ChangePasswordRequest) => {
    const callApi = makeApi.put<{}, ChangePasswordRequest, void>(
      `/v1/retailers/${retailerPartnerNumber}/users/${userId}/change-password`,
    )

    return await callApi({ params: {}, body: utils.object.convertToSnakeCase(body) })
  },
  resetPassword: async (body: ResetPasswordRequest, retailerPartnerNumber: number) => {
    const callApi = makeApi.post<{}, ResetPasswordRequest, void>(
      `/v1/retailers/${retailerPartnerNumber}/users/reset-password`,
    )

    return await callApi({ params: {}, body })
  },
}
